// Module
var code = `<div class="page"> <div class="panel"> You have not posted any job offers. </div> </div>`;
// Exports
export default code;